export const HEATMAPS_HEATMAP_TYPES = {
    movement: 'movement',
    scroll: 'scroll',
    click: 'click',
};

